<template>
  <div class="app-page-header">
    <div class="header-content">
      <h1 class="title" :class="{ 'title-gradient': useGradient }">{{ title }}</h1>
      <p v-if="subtitle" class="subtitle">{{ subtitle }}</p>
      <div v-if="$slots.meta" class="header-meta">
        <slot name="meta"></slot>
      </div>
    </div>
    <div class="actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
/// <reference types="vue" />
// @ts-ignore
import { computed } from 'vue'

// Define props interface
interface Props {
  title: string
  subtitle?: string
  useGradient?: boolean
}

// Define props with defaults
const props = withDefaults(defineProps<Props>(), {
  subtitle: '',
  useGradient: true
})
</script>

<style scoped>
.app-page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: var(--space-lg) 0;
  margin-bottom: var(--space-md);
  position: relative;
  border-bottom: 1px solid var(--neutral-100);
}

.header-content {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.title {
  font-size: var(--font-size-3xl);
  font-weight: 700;
  color: var(--neutral-900);
  margin: 0;
  line-height: 1.2;
  letter-spacing: -0.5px;
  position: relative;
}

.title-gradient {
  background-image: linear-gradient(45deg, var(--primary), var(--primary-dark));
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
}

.subtitle {
  font-size: var(--font-size-md);
  color: var(--neutral-600);
  margin: var(--space-xs) 0 0;
  font-weight: normal;
  max-width: 650px;
}

.header-meta {
  display: flex;
  gap: var(--space-sm);
  margin-top: var(--space-md);
  color: var(--neutral-500);
  font-size: var(--font-size-sm);
}

.actions {
  display: flex;
  gap: var(--space-sm);
  align-items: center;
}

@media (max-width: 768px) {
  .app-page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--space-md);
  }
  
  .actions {
    width: 100%;
    justify-content: flex-start;
  }
  
  .title {
    font-size: var(--font-size-2xl);
  }
}
</style>
